/* MAISON NOIR — theme.js */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ===== Money ===== */
  var MONEY_FORMAT = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
  function formatMoney(cents, format) {
    format = format || MONEY_FORMAT;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = withCommas + '.' + parts[1];
    return format.replace(/\{\{\s*amount\s*\}\}/g, amount)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas);
  }

  /* ===== Cart drawer =====
     Renders /cart.js into a slide-in panel with focus trap + Escape.
     Every add-to-cart on the site routes through open(), so the drawer is the
     single confirmation surface. */
  var Cart = (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return { open: function () {}, refresh: function () { return Promise.resolve(); }, close: function () {} };

    var panel = root.querySelector('[data-cart-panel]');
    var body = root.querySelector('[data-cart-body]');
    var foot = root.querySelector('[data-cart-foot]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var lastFocused = null;

    function money(c) { return formatMoney(c); }

    function esc(str) { return String(str == null ? '' : str).replace(/"/g, '&quot;'); }

    function lineMarkup(item, index) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" alt="' + esc(item.product_title) + '" loading="lazy">'
        : '<span class="cart-line__placeholder" aria-hidden="true">' +
          esc((item.product_title || '·').charAt(0)) + '</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
      var priceLine = item.original_line_price > item.final_line_price
        ? '<s>' + money(item.original_line_price) + '</s> <span class="sale">' + money(item.final_line_price) + '</span>'
        : money(item.final_line_price);
      return '' +
        '<li class="cart-line" data-cart-line="' + (index + 1) + '">' +
          '<a class="cart-line__media" href="' + item.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="cart-line__info">' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<div class="cart-line__controls">' +
              '<div class="qty-input qty-input--sm">' +
                '<button type="button" data-line-decr aria-label="Decrease quantity">&minus;</button>' +
                '<input type="number" value="' + item.quantity + '" min="0" data-line-qty aria-label="Quantity">' +
                '<button type="button" data-line-incr aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<span class="cart-line__price numeric">' + priceLine + '</span>' +
        '</li>';
    }

    function render(cart) {
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<div class="cart-drawer__empty">' +
          '<p class="display-md display-italic">' + (body.getAttribute('data-empty') || 'Your cart is empty') + '</p>' +
          '</div>';
        foot.hidden = true;
        return;
      }
      body.innerHTML = '<ul class="cart-drawer__lines">' + cart.items.map(lineMarkup).join('') + '</ul>';
      subtotalEl.textContent = money(cart.total_price);
      foot.hidden = false;
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
          return cart;
        });
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocused = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      document.addEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        var closeBtn = panel.querySelector('[data-cart-close]');
        if (closeBtn) closeBtn.focus();
      }, reducedMotion ? 0 : 260);
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function changeLine(line, qty) {
      root.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line.getAttribute('data-cart-line'), 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {})
        .then(function () { root.classList.remove('is-busy'); });
    }

    body.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var input = line.querySelector('[data-line-qty]');
      if (e.target.closest('[data-line-incr]')) changeLine(line, parseInt(input.value, 10) + 1);
      else if (e.target.closest('[data-line-decr]')) changeLine(line, parseInt(input.value, 10) - 1);
      else if (e.target.closest('[data-line-remove]')) changeLine(line, 0);
    });
    body.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      var line = e.target.closest('[data-cart-line]');
      changeLine(line, Math.max(0, parseInt(e.target.value, 10) || 0));
    });

    root.querySelectorAll('[data-cart-close], [data-cart-overlay]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    return { open: function () { return refresh().then(open); }, refresh: refresh, close: close };
  })();

  // Open the drawer from any header cart link instead of navigating away.
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
  });

  /* ----- Mobile menu ----- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    var setMenu = function (open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    toggle.addEventListener('click', function () {
      setMenu(!nav.classList.contains('is-open'));
    });

    // Escape closes it and hands focus back to the control that opened it,
    // so keyboard users aren't stranded inside a panel they can't see.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setMenu(false);
        toggle.focus();
      }
    });

    // Following a link should leave the menu closed behind you.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  /* ----- Header: settle on scroll ----- */
  var header = document.querySelector('.site-header');
  if (header) {
    var ticking = false;
    var setHeaderState = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    setHeaderState();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(setHeaderState); ticking = true; }
    }, { passive: true });
  }

  /* ----- Scroll reveal (with optional stagger across a group's children) ----- */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealObserver = null;
  if ('IntersectionObserver' in window && !reducedMotion) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }

  function initReveals(root) {
    root = root || document;
    root.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.classList.add('reveal');
        if (!reducedMotion) child.style.transitionDelay = Math.min(i * 70, 560) + 'ms';
      });
    });
    var revealables = root.querySelectorAll('.reveal:not(.is-visible)');
    if (revealObserver) {
      revealables.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }
  initReveals(document);

  // In the theme editor Shopify re-renders a section's markup when you edit it
  // (e.g. upload an image). Those fresh nodes start hidden at opacity:0. Reveal
  // them straight away (don't wait on the observer — the section is the one the
  // merchant is actively editing, so it should show at once) and prep any new
  // stagger groups.
  function revealNow(root) {
    root.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child) {
        child.classList.add('reveal');
      });
    });
    root.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      el.style.transitionDelay = '0ms';
      el.classList.add('is-visible');
    });
  }
  document.addEventListener('shopify:section:load', function (e) { revealNow(e.target); });
  document.addEventListener('shopify:section:select', function (e) { revealNow(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest('.shopify-section');
    if (sec) revealNow(sec);
  });

  /* ----- Market diagnostics reveal (?debug=market on any product URL) ----- */
  var marketDebug = document.querySelector('[data-market-debug]');
  if (marketDebug && /(^|[?&])debug=market(&|$)/.test(window.location.search.slice(1))) {
    marketDebug.hidden = false;
  }

  /* ----- Currency selector ----- */
  document.querySelectorAll('.currency-form').forEach(function (form) {
    // Preserve the full path INCLUDING query params (e.g. ?variant=123) so the
    // shopper stays on the exact variant they were viewing after switching
    // currency. Liquid can't supply the query string, so set it here.
    var syncReturnTo = function () {
      var field = form.querySelector('[data-return-to]');
      if (field) field.value = window.location.pathname + window.location.search;
    };
    syncReturnTo();
    form.addEventListener('submit', syncReturnTo);

    var sel = form.querySelector('[data-currency-select]');
    if (sel) {
      sel.addEventListener('change', function () { syncReturnTo(); form.submit(); });
    }
  });

  /* ----- Count-up stats (social proof) ----- */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length) {
    var formatCount = function (n) { return Math.round(n).toLocaleString('en-US'); };
    var runCount = function (el) {
      var target = parseFloat(el.getAttribute('data-count-to')) || 0;
      if (reducedMotion) { el.textContent = formatCount(target); return; }
      var duration = 1600, start = null;
      var ease = function (t) { return 1 - Math.pow(1 - t, 3); }; // easeOutCubic
      var tick = function (ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        el.textContent = formatCount(target * ease(progress));
        if (progress < 1) window.requestAnimationFrame(tick);
        else el.textContent = formatCount(target);
      };
      el.textContent = formatCount(0);
      window.requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window) {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { runCount(e.target); countObserver.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      counters.forEach(function (el) { countObserver.observe(el); });
    } else {
      counters.forEach(runCount);
    }
  }

  /* ----- Quantity steppers ----- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var floor = parseInt(input.min || '1', 10);
    if (isNaN(floor)) floor = 1;
    var next = Math.max(floor, (parseInt(input.value, 10) || floor) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Cart line quantity (cart page) ----- */
  document.querySelectorAll('[data-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line-qty');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ----- Product form: variant selection + AJAX add to cart ----- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsJson = document.querySelector('[data-product-variants]');
    var variants = [];
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent) || [];
      } catch (e) {
        // Malformed variant data must never take the buy button down — leave the
        // server-rendered (Liquid, market-aware) state exactly as it is.
        variants = [];
      }
    }
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');
    // Variant prices are pre-formatted by Liquid in the active market's
    // currency, so no client-side money formatting is needed here.

    /* ----- Gallery: main stage + thumbnails ----- */
    var mainImage = document.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-image-id]'));
    var stageEl = document.querySelector('.product-gallery__stage');

    /* Match the tile behind the photo to the photo's own background so its
       edges disappear (white-on-offwhite seams, etc.). Samples the border
       pixels; bails out (keeping the default) when edges aren't a clean,
       uniform studio background or the pixels can't be read. */
    function matchStageToImage(img) {
      if (!stageEl || !img || !img.naturalWidth) return;
      try {
        var N = 32;
        var canvas = document.createElement('canvas');
        canvas.width = N; canvas.height = N;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, N, N);
        var data = ctx.getImageData(0, 0, N, N).data;
        var sum = [0, 0, 0], sq = [0, 0, 0], count = 0;
        for (var y = 0; y < N; y++) {
          for (var x = 0; x < N; x++) {
            if (x !== 0 && x !== N - 1 && y !== 0 && y !== N - 1) continue; // border ring only
            var i = (y * N + x) * 4;
            if (data[i + 3] < 200) return;           // transparent edges: keep default
            for (var c = 0; c < 3; c++) { sum[c] += data[i + c]; sq[c] += data[i + c] * data[i + c]; }
            count++;
          }
        }
        for (var c2 = 0; c2 < 3; c2++) {
          var mean = sum[c2] / count;
          var std = Math.sqrt(Math.max(sq[c2] / count - mean * mean, 0));
          if (std > 24) return;                       // wildly varied edges: not a studio bg
        }
        // Lifestyle shots vary across the frame: compare the four corner patches
        // and bail when any pair disagrees noticeably.
        var patch = function (px, py) {
          var t = [0, 0, 0], n = 0;
          for (var yy = py; yy < py + 5; yy++) {
            for (var xx = px; xx < px + 5; xx++) {
              var j = (yy * N + xx) * 4;
              t[0] += data[j]; t[1] += data[j + 1]; t[2] += data[j + 2]; n++;
            }
          }
          return [t[0] / n, t[1] / n, t[2] / n];
        };
        var corners = [patch(0, 0), patch(N - 5, 0), patch(0, N - 5), patch(N - 5, N - 5)];
        for (var a1 = 0; a1 < corners.length; a1++) {
          for (var b1 = a1 + 1; b1 < corners.length; b1++) {
            for (var c3 = 0; c3 < 3; c3++) {
              if (Math.abs(corners[a1][c3] - corners[b1][c3]) > 14) return;
            }
          }
        }
        stageEl.style.setProperty('--stage-bg',
          'rgb(' + Math.round(sum[0] / count) + ',' + Math.round(sum[1] / count) + ',' + Math.round(sum[2] / count) + ')');
      } catch (e) { /* cross-origin or decode issue: keep the default tile */ }
    }
    if (mainImage) {
      if (mainImage.complete && mainImage.naturalWidth) matchStageToImage(mainImage);
      else mainImage.addEventListener('load', function () { matchStageToImage(mainImage); });
    }

    function setGalleryImage(imageId) {
      if (!mainImage || imageId == null) return;
      var thumb = thumbs.filter(function (t) {
        return t.getAttribute('data-image-id') === String(imageId);
      })[0];
      if (!thumb) return;
      var full = thumb.getAttribute('data-full');
      if (full && mainImage.getAttribute('src') !== full) {
        mainImage.style.opacity = '0';
        var loader = new Image();
        loader.crossOrigin = 'anonymous';
        loader.onload = function () { mainImage.src = full; mainImage.style.opacity = ''; matchStageToImage(loader); };
        loader.onerror = function () { mainImage.src = full; mainImage.style.opacity = ''; };
        loader.src = full;
      }
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setGalleryImage(t.getAttribute('data-image-id')); });
    });

    /* ----- Hover-zoom on the main stage (fine pointer only) ----- */
    var stage = document.querySelector('.product-gallery__stage');
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (stage && mainImage && finePointer && !reducedMotion) {
      stage.classList.add('is-zoomable');
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zooming'); });
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImage.style.setProperty('--zoom-x', x + '%');
        mainImage.style.setProperty('--zoom-y', y + '%');
      });
    }

    function currentOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) opts[parseInt(fs.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function syncVariant() {
      clearFormError();
      // No usable variant data (e.g. it failed to parse) — leave the
      // server-rendered button and price alone. Liquid already rendered the
      // correct, market-aware state; guessing here would only make it wrong.
      if (!variants.length) return;
      // No option pickers on the page (single default-variant product):
      // there is nothing to match against, so the server-rendered state is
      // already the whole truth. Matching here would wrongly report
      // "Unavailable" because zero selections can't equal "Default Title".
      if (!productForm.querySelector('[data-option-index]')) return;

      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) {
          // Prices arrive pre-formatted in the active market's currency,
          // so no client-side money conversion happens here.
          priceEl.innerHTML = match.on_sale
            ? '<span class="sale">' + match.price + '</span> <s>' + match.compare_at_price + '</s>'
            : match.price;
        }
        if (addBtn) {
          // Only treat a variant as sold out when Shopify explicitly says
          // available === false. Anything else (missing/undefined) stays
          // purchasable rather than falsely showing "Sold out".
          var soldOut = match.available === false;
          addBtn.disabled = soldOut;
          addBtn.querySelector('span').textContent = soldOut
            ? addBtn.getAttribute('data-label-soldout')
            : addBtn.getAttribute('data-label-add');
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        if (match.featured_image_id != null) setGalleryImage(match.featured_image_id);
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.querySelector('span').textContent = addBtn.getAttribute('data-label-unavailable');
      }
    }

    function updateOptionDisplays() {
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var display = fs.querySelector('[data-option-display]');
        if (checked && display) display.textContent = checked.value;
      });
    }
    updateOptionDisplays();

    productForm.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) { updateOptionDisplays(); syncVariant(); }
    });

    var errorEl = productForm.parentElement.querySelector('[data-form-error]') ||
                  document.querySelector('[data-form-error]');

    function showFormError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || errorEl.getAttribute('data-error-generic') || 'Could not add to cart.';
      errorEl.hidden = false;
    }
    function clearFormError() {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    }

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      clearFormError();
      if (addBtn) addBtn.disabled = true;
      var span = addBtn && addBtn.querySelector('span');
      var originalLabel = addBtn && addBtn.getAttribute('data-label-add');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(idInput.value, 10),
          quantity: parseInt(productForm.querySelector('[name="quantity"]').value || '1', 10)
        })
      })
        .then(function (r) {
          if (!r.ok) {
            // Shopify's cart API explains refusals (e.g. not sold in this
            // market) in the response body — surface that instead of hiding it.
            return r.json().then(
              function (err) { throw err; },
              function () { throw {}; }
            );
          }
          return r.json();
        })
        .then(function () {
          if (span) {
            span.textContent = addBtn.getAttribute('data-label-added');
            window.setTimeout(function () { span.textContent = originalLabel; }, 2000);
          }
          if (addBtn) addBtn.disabled = false;
          return Cart.open();   // slide the drawer in as the confirmation
        })
        .catch(function (err) {
          if (addBtn) addBtn.disabled = false;
          // Server refusals are plain objects with a description (e.g. "not
          // available in your region"); network failures throw Error instances.
          var isServerRefusal = err && !(err instanceof Error);
          var msg = isServerRefusal
            ? (typeof err.description === 'string' ? err.description
               : typeof err.message === 'string' ? err.message : '')
            : '';
          if (isServerRefusal) {
            showFormError(msg);   // falls back to the generic text when empty
          } else {
            // Network-level failure: browser's native submit (does not
            // re-trigger this listener).
            productForm.submit();
          }
        });
    });
  }
})();
